export default {
  en: {
    loadingProfile: 'Loading profile',
  },
  ru: {
    loadingProfile: 'Загружаем профиль',
  },
  de: {
    loadingProfile: 'Profil wird geladen',
  },
  pt: {
    loadingProfile: 'Carregando perfil',
  },
  fr: {
    loadingProfile: 'Chargement du profil',
  },
  es: {
    loadingProfile: 'Cargando perfil',
  },
};
